import { Link } from 'react-router-dom';
import { HiArrowLeft, HiHome } from 'react-icons/hi';

const NotFound = () => {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-6 py-12 animate-in fade-in duration-700">
      <div className="relative w-full max-w-lg text-center">
        {/* Decorative Background Element */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-10 select-none animate-float opacity-50 md:opacity-100">
          <span className="text-[12rem] md:text-[20rem] font-black text-slate-100 dark:text-slate-900/10 leading-none">
            404
          </span>
        </div>

        <div className="space-y-6 animate-in slide-in-from-bottom-8 duration-700 delay-150 fill-mode-both">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 mb-2 animate-bounce-slow">
            <svg
              className="w-10 h-10"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <div className="space-y-2">
            <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white tracking-tight">
              Oops! Page not found
            </h1>
            <p className="text-lg text-slate-600 dark:text-slate-400 max-w-md mx-auto">
              The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <button
              onClick={() => window.history.back()}
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-700 transition-all duration-300 shadow-sm hover:scale-105 active:scale-95"
            >
              <HiArrowLeft className="w-4 h-4" />
              Go Back
            </button>
            <Link
              to="/"
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-indigo-600 rounded-xl hover:bg-indigo-700 transition-all duration-300 shadow-lg shadow-indigo-600/20 hover:scale-105 active:scale-95"
            >
              <HiHome className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-100 dark:border-slate-800 animate-in fade-in duration-1000 delay-500 fill-mode-both">
          <p className="text-sm text-slate-500">
            If you think this is a mistake, please <Link to="/contact" className="text-indigo-600 hover:underline font-medium">contact support</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
